import { ClipboardEvent, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useSearchParams } from "react-router-dom";
import APIS from "../../constant/EndPoint";
import usePostHook from "../../customHooks/usePostHook";

const ScanQrCode = (props: any) => {
  const {
    setValue,
    operations,
    isactive,
    setError,
    clearErrors,
    setOpenDeliveryformPopup,
  } = props;
  const [waybillNumber, setWaybillNumber] = useState("");
  const inputRef = useRef<HTMLInputElement>(null);
  const handleChange = (event: any) => {
    setWaybillNumber(event.target.value);
  };

  const [searchParams, setSearchParms] = useSearchParams();
  const { mutateAsync: checkConsignmentsMutateAsync } = usePostHook({
    queryKey: ["received-manifest-items"],
  });
  const { mutateAsync: checkConsignmentsPickupMutateAsync } = usePostHook({
    queryKey: ["received-pickup-request-items"],
  });

  const handleKeyDown = (event: any) => {
    if (event.key === "Enter" && event.target.value?.length > 0) {
      event.preventDefault();
      event.stopPropagation();
      if (operations === "Manifest (Receive)") {
        handlecheckVehicleConsignments(event.target.value, setError);
        setWaybillNumber("");
      } else if (operations === "Pickup (Receive)") {
        handlecheckConsignmentspickup(event.target.value, setError);
        setWaybillNumber("");
      } else if (operations === "Delivery") {
        setOpenDeliveryformPopup((prev) => !prev);
        searchParams.set("selectedWayBillNumber", waybillNumber);
        setSearchParms(searchParams);
        setWaybillNumber("");
      } else {
        handlecheckVehicleConsignments(event.target.value, setError);
        setWaybillNumber("");
      }
    }
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  //   consignmentId: string,
  //   setError: any
  // ) => {
  //   const url = `${APIS.MANIFEST}receive-order/`;
  //   const formData = { tracking_number: consignmentId };
  //   return postApiData({
  //     url,
  //     formData,
  //     setError,
  //     clearErrors,
  //   });
  // };

  const handlecheckVehicleConsignments = async (
    consignmentId: string,
    setError: any
  ) => {
    const url = `${APIS.VEHICLE_MANIFEST_ITEMS}receive-order/`;
    const formData = { tracking_number: consignmentId };
    try {
      await checkConsignmentsMutateAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };

  const handlecheckConsignmentspickup = async (
    consignmentId: string,
    setError: any
  ) => {
    const url = `${APIS.PICKUPREQUEST_ITEMS}receive-order/`;
    const formData = { tracking_number: consignmentId };
    try {
      await checkConsignmentsPickupMutateAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };

  const preventCopyPaste = (e: ClipboardEvent<HTMLInputElement>) => {
    {
      isactive === "trackbutton"
        ? (e.preventDefault(),
          toast.error("Copy and paste is not allowed here"))
        : "";
    }
  };

  return (
    <div
      className={tw`invisible md:visible w-3/5 text-left text-black -mt-2 px-4 relative`}
    >
      <input
        placeholder={"Scan Barcode"}
        ref={inputRef} // Correctly assign the ref to the input element
        type={"text"}
        onPaste={preventCopyPaste}
        value={waybillNumber}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        className={tw`w-full focus:outline-none bg-[#EEF5F4] p-2 mt-1`}
      />
    </div>
  );
};

export default ScanQrCode;
